import gql from "graphql-tag";

export const ListEvents = gql`
  query ListEvents (
    $filter: TableEventFilterInput, 
    $limit: Int,
    $nextToken: String
  )
  {
    listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      nextToken
      items {
        value: id 
        text: title
        type
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/private/admin/components/EventDropdown/graphql.js